import React, { useContext, useState } from "react";


import {
  MenuOutlined,
  QrcodeOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { downArrow, upArrow } from "../Common/SvgIcon";
import { swipeUparrow, swipeDown1 } from "../Common/SvgIcon";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import { FloatButton } from "antd";
import { FaExchangeAlt, FaLocationArrow } from "react-icons/fa";
// import QRModal from "../Common/QRModal";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import SlideSocialMedia from "../Common/socialMedia/SlideSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { Link } from "react-router-dom";
import ProfileCardUltra from "../Common/profileCards/ProfileCardUltra";
import ProfileCardGlassy from "../Common/profileCards/ProfileCardGlassy";
import WebsiteUltra from "../Common/websiteCards/WebsiteUltra";
import ReviewCardUltra from "../Common/reviewCards/ReviewCardUltra";
import DownloadCardUltra from "../Common/fileDownloadsCards/DownloadCardUltra";
import ContactCardGlassy from "../Common/contactCards/ContactCardGlassy";
import SlideSocialMedias from "../Common/socialMedia/SlideSocialMedias";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";

import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import ProfileCardPatent from "../Common/profileCards/ProfileCardPatent";
import ContactCardPrism from "../Common/contactCards/ContactCardPrism";
import HorsizontalscrollGlassy from "../Common/socialMedia/HorsizontalscrollGlassy";
import ContactCardpeasant from "../Common/contactCards/ContactCardpeasant";
import ContactCardpatent from "../Common/contactCards/ContactCardpatent";
import SlideSocialMediasPatent from "../Common/socialMedia/SlideSocialMediasPatent";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import { CardContext } from "../../store/CardContext";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";

// import SlideSocialMedias from '../Common/socialMedia/SlideSocialMedias';
function PatentTheme({ preview, card }) {


  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${personalDetails?.secondaryEmail}`;
    e.preventDefault();
  };
  const [cardData] = useContext(CardContext)

  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    files,
    file1,
    file2,
    file3,
    file4,
    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    checkExchangeContact,
    exchangeContact,
    footerText
  } = cardData

  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };

  // const Highlightcolor = Hcolor.hex ? Hcolor?.hex : "";
  // const Textcolor = Tcolor.hex ? Tcolor.hex : "#000000";
  // const Iconcolor = Icolor.hex ? Icolor.hex : "#000000";
  // const BgColor = Bcolor?.hex ? Bcolor?.hex : "";
  // const BtIColor = BtIconColor?.hex ? BtIconColor?.hex : "#FFFFFF";
  // const files = {
  //   file1: file1,
  //   file2: file2,
  //   file3: file3,
  //   file4: file4,
  // };
  const [isExpanded, setIsExpanded] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const handleClose = (e) => {
    setQrModal(false);
  };

  const HighlightImageCheck = HighlightImageValid();
  const SocialMediaImageCheck = SocialMediaValid();


  // const pfImage = profileImage[0]?.thumbUrl &&
  //   profileImage[0]?.status !== "removed" ? (
  //   profileImage[0]?.originFileObj?.type
  //     ? URL.createObjectURL(
  //       profileImage[0]?.originFileObj
  //     )
  //     : profileImage[0].thumbUrl
  // ) : defaultProfileImage

  const pfImage = profileImage ? profileImage : defaultProfileImage

  const imageStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${pfImage})`,
    backgroundRepeat: "no-repeat",
    // backgroundAttachment: "sticky"
  };

  const exchangeButton = (

    <span
      className="flex items-center justify-center "

    >
      <FaExchangeAlt size={14} color="black" />
    </span >
  )


  return (
    <>

      <div className="digitalcontainer6 ">
        <div className="digitalcontainer_center6  ">
          <div className="digitalcontainer_banner6 relative h-screen overflow-auto scrollbar-hide bg-black "   >

            <div className=" m-[15px]">
              <ProfileCardPatent preview={preview} />

            </div>
            <div className="flex m-[15px] gap-3">
              <div className={`scrollbar-hide bg-[#6E9FFF] ${!personalDetails?.about && 'hidden'}`} style={{
                width: personalDetails?.about ? '50%' : '100%', // Adjust width based on about content
                height: '300px', // Set the desired height
                borderTopLeftRadius: '0',
                borderTopRightRadius: personalDetails?.about ? '65px' : '36px',
                borderBottomRightRadius: personalDetails?.about ? '36px' : '0px',
                borderBottomLeftRadius: personalDetails?.about ? '36px' : '65px',
                overflowY: 'auto',
              }}>
                {personalDetails?.about && (
                  <>
                    <p className="text-white text-[20px] mt-4 font-bold text-center">About</p>
                    <div className="text-center">
                      <p className="text-white truncate text-[14px] font-medium whitespace-pre-line">
                        {personalDetails?.about}
                      </p>
                    </div>
                  </>
                )}
              </div>
              <div className='overflow-hidden truncate' style={{
                width: personalDetails?.about ? '50%' : '100%', // Adjust width based on about content
                height: '300px', // Set the same height as the other element
                borderTopLeftRadius: personalDetails?.about ? '36px' : '0px',
                borderTopRightRadius: personalDetails?.about ? '36px' : '0px',
                borderBottomRightRadius: personalDetails?.about ? '0px' : '65px',
                borderBottomLeftRadius: personalDetails?.about ? '0px' : '65px'
              }}>
                {/* {profileImage[0]?.thumbUrl && profileImage[0]?.status !== "removed" ? (
                  <img
                    className='sticky top-0 w-full h-full object-cover'
                    src={
                      profileImage[0]?.originFileObj?.type
                        ? URL.createObjectURL(profileImage[0]?.originFileObj)
                        : profileImage[0].thumbUrl
                    }
                    alt=""
                    style={{
                      borderTopLeftRadius: personalDetails?.about ? '36px' : '0px',
                      borderTopRightRadius: personalDetails?.about ? '36px' : '0px',
                      borderBottomRightRadius: personalDetails?.about ? '0px' : '65px',
                      borderBottomLeftRadius: personalDetails?.about ? '65px' : '0px'
                    }}
                  />
                ) : (
                  <img
                    className='sticky w-full h-full object-cover'
                    src={defaultProfileImage}
                    alt=""
                    style={{
                      borderTopLeftRadius: personalDetails?.about ? '36px' : '0px',
                      borderTopRightRadius: personalDetails?.about ? '36px' : '0px',
                      borderBottomRightRadius: personalDetails?.about ? '0px' : '65px',
                      borderBottomLeftRadius: personalDetails?.about ? '65px' : '0px'
                    }}
                  />
                )} */}

                <img
                  className='sticky w-full h-full object-cover'
                  src={profileImage ? profileImage : defaultProfileImage}
                  alt=""
                  style={{ borderRadius: '30px' }}
                />
              </div>
            </div>
            <div className="m-[15px]">
              <ContactCardpatent preview={preview} />
            </div>
            <div className="m-[15px]">
              {(socialMedias && socialMedias.length !== 0) ?
                // <SlideSocialMedia preview={preview} color={'white'} />
                <div className="bg-[#FFDE6A] p-3" style={{
                  borderTopLeftRadius: "36px",
                  borderTopRightRadius: "36px",
                  borderBottomRightRadius: "0px",
                  borderBottomLeftRadius: "36px"
                }}>

                  <SlideSocialMediasPatent preview={preview} color={'black'} />
                </div>
                : ""}
            </div>
            <div className={`${HighlightImageCheck ? 'bg-[#FFD6B8] m-[15px]' : ''}`} style={{
              borderTopLeftRadius: "36px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "36px",
              borderBottomLeftRadius: "36px"
            }}>

              <div className="text-start m-[15px] mb-0">
                <p className="text-black text-[20px] pt-[30px] font-bold">
                  {HighlightImageCheck ? "Gallery" : ""}
                </p>
                <div className="grid gap-3 grid-cols-2 pt-3 items-center ">
                  {HighlightImageCheck && <HighlightImage preview={preview} />}
                </div>
              </div>
            </div>
            {website[0]?.websiteName ? (
              <div className="bg-[#F8BBD0] m-[15px]" style={{
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "36px",
                borderBottomRightRadius: "36px",
                borderBottomLeftRadius: "36px"
              }}>
                <div className="w-1/2 overflow-auto scrollbar-hide  items-center">
                  <div className="flex items-center justify-start m-[15px] ">
                    <p className="text-[20px] text-black font-bold h-[0px] text-start">
                      Website
                    </p>
                  </div>
                  <div className=" justify-start ml-[15px] text-[20px] ">
                    <WebsiteBasic preview={preview} color={'black'} />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {review[0]?.reviewName ? (
              <div className="bg-[#DCEDC8] m-[15px]" style={{
                borderTopLeftRadius: "36px",
                borderTopRightRadius: "36px",
                borderBottomRightRadius: "36px",
                borderBottomLeftRadius: "0px"
              }}>
                <div className="w-1/2   overflow-auto scrollbar-hide    items-center   ">
                  <div className="flex items-cente m-[15px]  justify-start">
                    <p className="text-[20px] text-black font-bold h-[0px]  text-center">
                      Review
                    </p>
                  </div>
                  <div className=" justify-start ml-[15px] text-[20px]">
                    <ReviewCardBasic preview={preview} color={'black'} />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className={fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ? " " : ""}>
              {fileName?.fileName1 || fileName?.fileName2 || fileName?.fileName3 || fileName?.fileName4 ?
                <>
                  <div className="bg-[#80DEEA] m-[15px]" style={{
                    borderTopLeftRadius: "36px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "36px",
                    borderBottomLeftRadius: "36px"
                  }}>
                    <div className="p-3">
                      <h3 className="text-start  text-[20px] text-black font-bold ">
                        Downloads
                      </h3>
                      <div className="flex justify-start items-center">
                        <DownloadBasic files={files} fileName={fileName} preview={preview} color={"black"} />
                      </div>
                    </div>
                  </div>
                </>
                : ''
              }

            </div>

            {/*  --------------------------------- footer ---------------------------------  */}
            {footerText &&
              <Footer color={"#ffffff"} />
            }


            <div>

            </div>
          </div>

        </div>
        {
          preview ?


            <FloatButton.Group className="shadow-xl"
              trigger="click"
              color="black share_button"
              style={{
                left: "50%",
                color: "white",
                position: "fixed",
                bottom: 20,
                marginLeft: '-20px',

              }}
              icon={<MenuOutlined />}
            >

              {card?.exchangeContact?.show ? (
                <div onClick={(e) => e.stopPropagation()} className='mb-[12px]'>
                  <FloatButton
                    icon={
                      <ExchangeContact
                        customButton={exchangeButton}
                        details={card?.exchangeContact}
                        cardId={card._id}
                      />
                    }
                  />
                </div>
              ) : (
                ""
              )}
              <FloatButton
                icon={<ShareAltOutlined />}
                onClick={handleShare}
              />
              <FloatButton
                icon={<QrcodeOutlined />}
                onClick={() => setQrModal(true)}
              />
              <Link to={contactDetails?.locationUrl} target={`${preview ? "_blank" : ""}`}>
                <FloatButton icon={<FaLocationArrow />} />
              </Link>

            </FloatButton.Group>

            : ""}
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>

    </>
  );
}

export default PatentTheme;
